import { render, staticRenderFns } from "./StripeClub.vue?vue&type=template&id=36e80fef&scoped=true"
import script from "./StripeClub.vue?vue&type=script&lang=js"
export * from "./StripeClub.vue?vue&type=script&lang=js"
import style0 from "./StripeClub.vue?vue&type=style&index=0&id=36e80fef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e80fef",
  null
  
)

export default component.exports